export const KNOWLEDGE_URL = '/enciklopediya/';
export const KNOWLEDGE_TITLE = 'Энциклопедия';

export const SITEMAP_URL = '/karta-sajta/';
export const SITEMAP_TITLE = 'Карта сайта';
